module.exports = __webpack_public_path__ + "media/images/model-2b453dbfcf7b98c46e1a51e355a60517.jpg";